import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Button, DatePicker, Form, Modal, Select } from "antd";

import moment from "moment";

const METHODS = ["GET", "POST", "PUT", "DELETE"];

const dateRanges = () => ({
	"Hoje"          : [moment().startOf("day"), moment().endOf("day")],
	"Últimos 7 dias": [moment().subtract(6, "days").startOf("day"), moment().endOf("day")],
	"Este mês"      : [moment().startOf("month"), moment().endOf("day")],
	"Mês passado"   : [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
});

class Filters extends Component {
	static propTypes = {
		visible   : PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose   : PropTypes.func.isRequired,
		options   : PropTypes.object,
	};

	static defaultProps = {
		options: {
			users  : [],
			actions: [],
			items  : [],
		},
	};

	constructor(props) {
		super(props);

		this.filtersClean = {
			created_at: null,
			user_id   : null,
			action    : null,
			log_type  : null,
			method    : null,
		};

		this.state = {
			filters: {
				...this.filtersClean,
			},
		};
	}

	onOpen = (filters) => {
		this.setState({
			filters: filters,
		});
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	setFilter = (name, value) => {
		this.setState(state => ({
			filters: {
				...state.filters,
				[name]: value ?? null,
			}
		}));
	};

	cleanFilters = () => {
		this.setState({
			filters: {...this.filtersClean},
		}, () => {
			// Callback
			this.props.onComplete({...this.state.filters});
		});
	};

	filtersOnConfirm = () => {
		// Callback
		this.props.onComplete({...this.state.filters});
	};

	render() {
		const {visible, options} = this.props;
		const {filters}          = this.state;

		return (
			<Modal
				visible={visible}
				title="Filtrar"
				centered={true}
				destroyOnClose={true}
				maskClosable={true}
				width={900}
				okText="Aplicar"
				onCancel={this.onClose}
				onOk={this.filtersOnConfirm}
				className="modal-filters"
				footer={[
					<Button key="back" type="link" onClick={this.cleanFilters}>Excluir filtros</Button>,
					<Button key="submit" type="primary" onClick={this.filtersOnConfirm}>Aplicar</Button>,
				]}>
				<div className="filter-group">
					<div className="filter-group-title" style={{paddingTop: 0}}>
						<h3>Período</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<DatePicker.RangePicker
								format="DD/MM/YYYY"
								value={filters.created_at}
								onChange={(date) => this.setFilter("created_at", date ?? null)}
								disabledDate={(currentDate) => currentDate.isAfter(moment(), "day")}
								ranges={dateRanges()}
							/>
						</Form.Item>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Usuário</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<Select
								showSearch
								allowClear
								optionFilterProp="children"
								placeholder="Todos os usuários"
								value={filters.user_id ?? undefined}
								onChange={(value) => this.setFilter("user_id", value ?? null)}>
								{options.users.map(user => (
									<Select.Option key={user.id} value={user.id}>{`${user.id} - ${user.name}`}</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Tipo de alteração</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<Select
								allowClear
								placeholder="Todos"
								value={filters.action ?? undefined}
								onChange={(value) => this.setFilter("action", value ?? null)}>
								{options.actions.map(action => (
									<Select.Option key={action.value} value={action.value}>{action.label}</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Item</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<Select
								showSearch
								allowClear
								optionFilterProp="children"
								placeholder="Todos os itens"
								value={filters.log_type ?? undefined}
								onChange={(value) => this.setFilter("log_type", value ?? null)}>
								{options.items.map(item => (
									<Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
				<div className="filter-group">
					<div className="filter-group-title">
						<h3>Método</h3>
					</div>
					<div className="filter-group-filters" style={{paddingBottom: 0}}>
						<Form.Item>
							<Select
								allowClear
								placeholder="Todos"
								value={filters.method ?? undefined}
								onChange={(value) => this.setFilter("method", value ?? null)}>
								{METHODS.map(method => (
									<Select.Option key={method} value={method}>{method}</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div>
			</Modal>
		)
	}
}

export default Filters;
